import React, {useState, useEffect, useContext} from 'react';

import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';
import Start from './prawnik/start/Start';
import NewsCenter from './prawnik/powiadomienia/NewsCenter';
import ZadajBezplatnePytanie from './zadaj_bezplatne_pytanie/ZadajBezplatnePytanie';
import Potwierdzenie from './bezplatna_konsultacja_telefoniczna/potwierdzenie/Potwierdzenie';
import {Routes, Route} from 'react-router';
import {LawyerContext, CategoriesContext, LoadingContext, UserContext, ContextProcessor} from '../partials/Context';
import {getCategories, getLawyer} from '../functions/api';
import { Errors, Loader } from '../partials/Partials';
import Statistics from './prawnik/statystyka_profilu/Statistics';
import Portfel from './prawnik/portfel/Portfel';
import Oplac from './prawnik/portfel/Oplac';
import DataEdit from './prawnik/edycja/DataEdit';
import DodajPrawnika from './dodaj-prawnika/DodajPrawnika';
import ServicesNavigation from './zadaj_bezplatne_pytanie/ServicesNavigation';
import WKZapytajPrawnika from './zadaj_bezplatne_pytanie/WKZapytajPrawnika';
import Statystyki from './wolters_kluwer/Statystyki';



function LayoutBox(props) {
    const [lawyer, setLawyer] = useState({});
    const [categories, setCategories] = useState({});
    const [errors, setErrors] = useState([]);
    const {loading} = useContext(LoadingContext);
    const user = useContext(UserContext);
    const context = useContext(ContextProcessor);
    const {is_authenticated} = user || '';
    const [titles, setTitles] = useState([]);
    let lawyer_titles = [];
    let pathname = window.location.pathname.slice(1, -1).split('/');
    const {is_staff} = user || ''
    const {start_price_nett} = context;

    useEffect(()=> {
        function setLawyerAndPopup(data) {
            if (!data.is_premium_or_start && !(window.location.pathname.match(/prawnik-portfel\/(prawnik-[0-9]+\/([0-9]+\/)?)?$/) || window.location.pathname.startsWith('/oplac/'))) {
                document.getElementById('dialog').showModal();
            }
            setLawyer(data);
        }
        let token = null
        if (window.location.pathname.startsWith('/oplac/')) {
            token = window.location.pathname.split('/')[2]
        }
        if (is_authenticated) {
            getLawyer(setLawyerAndPopup, setErrors, token);
        }
        getCategories(setCategories, setErrors);
    },[is_authenticated])

    useEffect(() => {
        fetch('/api/titles/').then(res=>res.json().then(
            data => setTitles(data)
        ))
    },[])

    if (titles) {
        titles.forEach(item => {
            lawyer_titles.push(item.name.toLowerCase().split(' ').join('-'))
        })
        lawyer_titles.push('prawnik')
    }

    let category_slug = '';
    let categories_all = [];
    if (categories.prywatne && categories.firmowe) {
        const {prywatne, firmowe} = categories || ''
        categories_all = [...prywatne, ...firmowe]
    }

    if (pathname.length === 2 && pathname[0] === 'zadaj-bezplatne-pytanie') {
        let category_pathname = pathname[1];

        categories_all.forEach(category => {
            const {slug} = category || ''
            if (category_pathname === slug) {
                category_slug = category_pathname
            }
        })
    }

    let if_wallet_url = window.location.pathname.match(/prawnik-portfel\/(prawnik-[0-9]+\/([0-9]+\/)?)?$/)
    let if_WK = window.location.pathname.match(/zapytaj-prawnika(\/kategoria\/[a-zA-Z0-9\-_]+)?\/wk\/$/);

    let if_simplified = window.location.pathname === '/statystyki/' || window.location.pathname.startsWith('/oplac/')
    let contentId = if_simplified ? '' : 'content'

        return (
            <LawyerContext.Provider value={lawyer}>
                <dialog id="dialog" className="popup">
                  <form method="dialog">
                      <button className="close" aria-label="Zamknij">×</button>
                      <h3>Twój profil nie jest widoczny dla klientów</h3>
                      <p>Aktywacja kosztuje <strong>{start_price_nett}&nbsp;zł netto / miesiąc</strong>. Po opłaceniu profil natychmiast pojawi się w&nbsp;katalogu.</p>
                      <div className="popup-actions">
                        <a href="/prawnik-portfel/" className="btn-primary" autoFocus>Aktywuj profil — {start_price_nett}&nbsp;zł netto / mies.</a>
                        <a className="btn-link" href="mailto:kontakt@specprawnik.pl">Masz pytania?</a>
                      </div>
                  </form>
                </dialog>
                <Navbar simplified={if_simplified}/>
                <CategoriesContext.Provider value={categories}>
                <div className="layout-box">
                    <div className="container">
                        <div id={contentId} className="row">
                            <div className="row">
                            <Errors errors={errors} />
                                <Routes>
                                <Route path='prawnik/start/'element={<Start/>}/>
                                <Route path='prawnik/powiadomienia/'element={<NewsCenter/>}/>
                                <Route path='prawnik/statystyka-profilu/'element={<Statistics/>}/>
                                <Route path='prawnik/edycja/*' element={<DataEdit />}/>
                                <Route exact path={ `/zadaj-bezplatne-pytanie/`} element={<ZadajBezplatnePytanie/>}/>
                                <Route exact path={ `/zadaj-bezplatne-pytanie/${category_slug}`} element={<ServicesNavigation/>}/>
                                <Route exact path="dodaj-prawnika/" element={<DodajPrawnika />} />
                                <Route path={`/bezplatna-konsultacja-telefoniczna/potwierdzenie/*`} element={<Potwierdzenie/>} />
                                <Route exact path="statystyki/" element={<Statystyki/>} />
                                {if_WK ?
                                <Route path={'/zapytaj-prawnika/kategoria/*'} element={<WKZapytajPrawnika/>}/>
                                :null
                                }
                                {if_wallet_url ?
                                    is_staff ? 
                                        <Route path='prawnik-portfel/*' element={<Portfel />}/>
                                    : <Route path='prawnik-portfel/' element={<Portfel />}/>
                                : null
                                }
                                <Route path='oplac/*' element={<Oplac />}/>
                                </Routes>
                            </div>
                        </div>
                    </div>
                </div>
                </CategoriesContext.Provider>
                <Footer simplified={if_simplified}/>
                <Loader classes={`${loading ? 'active' : ''}`}/>
            </LawyerContext.Provider>
        )
}

export default LayoutBox